import React from 'react';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const benefits = [
  {
    title: 'Timeline Intelligence',
    description: 'See audio energy, speech highlights, sentiment, and scene changes layered in one clip timeline.',
  },
  {
    title: 'Brand-Ready Captions',
    description: 'Keep brand fonts, colors, and emoji styles synced across every export automatically.',
  },
  {
    title: 'Cross-Platform Exports',
    description: 'Render TikTok, Shorts, and Reels versions simultaneously with safe-area guides.',
  },
];

const ClipsOverview: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Clip Library"
        description="Organize, edit, and publish video clips directly inside ClipThis."
        url="/clips"
      />
      <BreadcrumbSchema items={[{ name: 'Clips', path: '/clips' }]} />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Clip Library</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Every highlight in one place</h1>
          <p className="text-lg text-gray-600 mb-10">
            Search, filter, and share clips instantly. Tag moments by guest, topic, or platform, then export without re-uploading footage.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            {benefits.map((benefit) => (
              <div key={benefit.title} className="p-6 rounded-2xl border border-gray-200 bg-gray-50">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">{benefit.title}</h2>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default ClipsOverview;

